import { Card, Grid, Typography, Divider } from "@material-ui/core";
import React from "react";
import { useTranslation } from "react-i18next";
import MediaContainer from "./MediaContainer";

const INDENT_LEVEL_1 = [
    "C1S3_4", "C1S3_5", "C1S3_6", "C1S3_7", "C1S3_10", "C1S3_11", "C1S3_12",
    "C1S3_18", "C1S3_19", "C1S4_2", "C1S4_3", "C1S4_4", "C1S4_5",
    "C2S4_2", "C2S4_3", "C2S4_4", "C2S4_5",
    "C3S2_3", "C3S2_4", "C3S2_5", "C3S2_6", "C3S2_9",
    "C3S3_4", "C3S6_2", "C3S6_3", "C3S6_4",
];

const INDENT_LEVEL_2 = [
    "C2S4_6", "C2S4_7", "C2S4_8", "C2S4_10",
    "C3S2_7", "C3S2_8",
];

// 🔹 NUEVO: helper de layout
const getParagraphLayout = (text, key) => {
    const normalizedText = text.replace(/&nbsp;/g, " ").trim();
    const plainText = normalizedText.replace(/<[^>]*>/g, "").trim();

    const markerMatch = plainText.match(/^(\d+\.|•)\s*(.*)$/);

    const fallbackIndentLevel = INDENT_LEVEL_2.includes(key)
        ? 2
        : INDENT_LEVEL_1.includes(key)
            ? 1
            : 0;

    if (!markerMatch) {
        return {
            type: "paragraph",
            text,
            indentLevel: fallbackIndentLevel,
        };
    }

    return {
        type: "list",
        marker: markerMatch[1],
        text: normalizedText.replace(/^(\d+\.|•)\s*/, ""),
        indentLevel: markerMatch[1] === "•" ? 2 : 1,
    };
};

export const CourseItem = ({ data }) => {
    const { t } = useTranslation();

    return (
        <Grid container>
            <Grid
                container
                direction="column"
                justify="center"
                alignItems="center"
                style={{ marginTop: 32, marginBottom: 48 }}
            >
                <Grid item xs={12} lg={9}>
                    <Typography
                        className="header"
                        variant="h3"
                        style={{
                            textTransform: "uppercase",
                            fontWeight: 300,
                            marginBottom: 18,
                            textAlign: "center",
                        }}
                    >
                        {!!data.title && t(data.title)}
                    </Typography>

                    {!!data.subtitle && (
                        <Typography
                            variant="h5"
                            style={{ color: "grey", textAlign: "center" }}
                            dangerouslySetInnerHTML={{ __html: t(data.subtitle) }}
                        />
                    )}
                </Grid>
            </Grid>

            {data.section &&
                data.section.map((section, sectionIndex) => (
                    <Grid container justify="center" key={sectionIndex}>
                        <Grid item xs={12} container justify="center">
                            {!!section.title && (
                                <Typography
                                    variant="h5"
                                    component="h4"
                                    style={{ textTransform: "uppercase", marginBottom: 24 }}
                                    dangerouslySetInnerHTML={{ __html: t(section.title) }}
                                />
                            )}
                        </Grid>

                        {section.containers.map((container, containerIndex) => (
                            <Grid item xs={12} lg={9} container key={containerIndex}>
                                <Grid
                                    item
                                    container
                                    justify="center"
                                    alignItems="center"
                                    lg={container.type === "single" ? 0 : container.aspect_ratio[0]}
                                >
                                    {container.type === "double" && (
                                        <MediaContainer container={container} />
                                    )}
                                </Grid>

                                <Grid item lg={container.type === "single" ? 12 : container.aspect_ratio[1]}>
                                    {container.p.map((p, pIndex) => {
                                        const text = t(p.text);
                                        const layout = getParagraphLayout(text, p.text);

                                        if (layout.type === "list") {
                                            return (
                                                <Typography
                                                    key={pIndex}
                                                    variant="body1"
                                                    style={{
                                                        display: "grid",
                                                        gridTemplateColumns: "28px 1fr",
                                                        columnGap: 8,
                                                        paddingLeft: layout.indentLevel === 2 ? 88 : 48,
                                                        marginBottom: 16,
                                                        alignItems: "start",
                                                    }}
                                                >
                                                    <span>{layout.marker}</span>
                                                    <span
                                                        style={{ textAlign: "justify" }}
                                                        dangerouslySetInnerHTML={{ __html: layout.text }}
                                                    />
                                                </Typography>
                                            );
                                        }

                                        return (
                                            <Typography
                                                key={pIndex}
                                                variant="body1"
                                                style={{
                                                    textAlign: "justify",
                                                    marginBottom: 16,
                                                    paddingLeft:
                                                        layout.indentLevel === 2
                                                            ? 88
                                                            : layout.indentLevel === 1
                                                                ? 48
                                                                : 0,
                                                }}
                                                dangerouslySetInnerHTML={{ __html: layout.text }}
                                            />
                                        );
                                    })}
                                </Grid>
                            </Grid>
                        ))}

                        {!!section.alert && (
                            <Grid item xs={12} lg={9}>
                                <Card
                                    style={{
                                        backgroundColor: section.alert.color,
                                        marginTop: 16,
                                        marginBottom: 32,
                                        padding: 16,
                                    }}
                                >
                                    <Grid container justify="center">
                                        {!!section.alert.title && (
                                            <Typography
                                                variant="h5"
                                                style={{ fontWeight: 500, marginBottom: 12 }}
                                                dangerouslySetInnerHTML={{ __html: t(section.alert.title) }}
                                            />
                                        )}

                                        <Typography
                                            variant="body1"
                                            style={{ textAlign: "center", fontWeight: 500 }}
                                            dangerouslySetInnerHTML={{ __html: t(section.alert.text) }}
                                        />
                                    </Grid>
                                </Card>
                            </Grid>
                        )}

                        {sectionIndex < data.section.length - 1 && (
                            <Grid item xs={12} lg={8}>
                                <Divider style={{ marginBottom: 64, marginTop: 12 }} />
                            </Grid>
                        )}
                    </Grid>
                ))}
        </Grid>
    );
};